export default __webpack_public_path__ + "static/Animacion3D-Proyeccion-Mexico-55b930cc66565b1f68a95a99e8bb03db.jpg";